module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_T.96ff9d7f.jpg";